import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { EligibiliteBeneficiaire } from 'src/app/shared/models/eligibiliteBeneficiaire';

@Component({
	selector: 'app-eligibiliteBeneficiaire-modal-detail',
	templateUrl: './eligibiliteBeneficiaire-modal-detail.component.html',
	styleUrls: ['./eligibiliteBeneficiaire-modal-detail.component.scss']
})
export class EligibiliteBeneficiaireModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required
		])
	});

	eligibiliteBeneficiaire: EligibiliteBeneficiaire;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.eligibiliteBeneficiaire ? this.eligibiliteBeneficiaire.name : null
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.eligibiliteBeneficiaire.name = this.formEdit.get('name').value;
		this.facade.eligibiliteBeneficiaireService.updateEligibiliteBeneficiaire(this.eligibiliteBeneficiaire).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.eligibiliteBeneficiaireService
			.deleteEligibiliteBeneficiaire(this.eligibiliteBeneficiaire.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.eligibiliteBeneficiaireService
			.deleteEligibiliteBeneficiaire(this.eligibiliteBeneficiaire.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
